import { Component } from '@angular/core';
import {BreadcrumbHeaderComponent} from '../../../LandingPage/NavigationMenu/page-headline/page-headline.component';
import {NgForOf} from '@angular/common';
import {ColorScssService} from '../../../shared/service/color-scss.service';
import {CallToActionSectionComponent} from '../call-to-action-section/call-to-action-section.component';
import {YourAdvantagesSectionComponent} from '../your-advantages-section/your-advantages-section.component';
import {FeatureRowDescriptionSectionComponent} from '../feature-row-description-section/feature-row-description-section.component';
import {HowItWorksSectionComponent} from '../how-it-works-section/how-it-works-section.component';

@Component({
  selector: 'app-feature-page',
  standalone: true,
  imports: [
    BreadcrumbHeaderComponent,
    CallToActionSectionComponent,
    YourAdvantagesSectionComponent,
    FeatureRowDescriptionSectionComponent,
    HowItWorksSectionComponent
  ],
  templateUrl: './feature-page.component.html',
  styleUrl: './feature-page.component.scss'
})
export class FeaturePageComponent {
  constructor(private color: ColorScssService) {
    this.color.resetColorScheme()
  }
}
